class RichTextResultVM extends BaseResultVM {
    processedText: string;
    ///HTML with tags replaced by metric name and filter name
    htmlText: string;

    constructor(data) {
        super(data);

        this.processedText = data?.processedText;
        this.htmlText = data?.htmlText;
    }
}

enum VariableTypeEnum {
    Metric,
    Filter
}
enum VariableFilterTypeEnum {
    Default,
    Metric,
    Widget
}

class VariableHtmlEditor {
    name: string;
    tag: string;
    icon: string;
    items: Array<VariableHtmlEditor>;

    constructor(name: string, tag: string, icon: string = null) {
        this.name = name;
        this.tag = tag;
        this.icon = icon;
        this.items = [];
    }
}
class VariableRichText extends VariableHtmlEditor  {
    type: VariableTypeEnum;
    filterType: VariableFilterTypeEnum;
    filterEditorType: FilterEditorTypeEnum;

    constructor(type: VariableTypeEnum, name: string, filterEditorType: FilterEditorTypeEnum = FilterEditorTypeEnum.None, filterType: VariableFilterTypeEnum = VariableFilterTypeEnum.Default, variable: IDateVariation = null) {
        super(name, "", "");

        this.type = type;
        this.filterType = filterType;
        this.name = name;

        if (this.type === VariableTypeEnum.Filter || this.type === VariableTypeEnum.Metric) {
            this.icon = "htmleditor-menu-icon ms " + Filter.getIcon(filterEditorType, type === VariableTypeEnum.Metric || filterType == VariableFilterTypeEnum.Metric, true);
        }

        this.filterEditorType = filterEditorType;

        this.tag = this.name;
        if (variable) {
            this.name = variable.text;
            this.tag = `${name}|${variable.id}`;
        }

        if (this.type === VariableTypeEnum.Filter) {
            if (this.filterType === VariableFilterTypeEnum.Metric) {
                this.tag = `[Metric Filter ${this.tag}]`;
            }
            else if (this.filterType === VariableFilterTypeEnum.Widget) {
                this.tag = `[Widget Filter ${this.tag}]`;
            }
            else {
                this.tag = `[Filter ${this.tag}]`;
            }
        }
        else {
            this.tag = `[${this.tag}]`;
        }
    }
}